'use strict'

import axios from '@/plugins/axios-instance.js'
import { shipmentService, quoteService, locationService, vehicleService, userService } from '@/_services'
import { shipmentHelper } from '@/_helpers'
import * as type from './types'
import i18n from '@/i18n'

const url =
  'https://mcy60x6ypc.execute-api.eu-west-1.amazonaws.com/prod/shipments/'

const actions = {
  fetchShipments ({ commit }) {
    commit(type.REQUEST_LIST_SHIPMENTS)
    axios
      .get(url)
      .then(resp => {
        commit(type.REQUEST_LIST_SHIPMENTS_SUCCESS, {
          payload: resp.data
        })
      })
      .catch(error => {
        commit(type.REQUEST_LIST_SHIPMENTS_ERROR, {
          error
        })
      })
  },

  toggleShipments2 ({ commit }, { flag, shipmentID }) {
    if (flag === 'empty' && shipmentID === null) {
      commit(type.EMPTY_TOGGLE_SHIPMENTS2)
    } else {
      commit(type.TOGGLE_SHIPMENTS2, { flag, shipmentID })
    }
  },
  setShipmentDetails ({ commit }, { shipmentID }) {
    commit(type.SET_SHIPMENT_IS_FETCHING, { isFetching: true })
    shipmentService.getShipment({ shipmentID }).then((response) => {
      commit(type.SET_SELECTED_SHIPMENT, { shipment: response })
      commit('UPDATE_SELECTED_RESOURCE', { resource: { ...response } })
    }).finally(() => {
      commit(type.SET_SHIPMENT_IS_FETCHING, { isFetching: false })
    })
  },
  fetchShipmentDetails ({ commit }, { shipmentID }) {
    shipmentService.getShipment({ shipmentID: this.getSelectedResourceID.objectID }).then((response) => {
      commit(type.SET_SELECTED_SHIPMENT, { shipment: response })
    }).catch((error) => {
      console.log(error)
    })
  },
  removeShipmentDetails ({ commit }) {
    commit(type.REMOVE_SELECTED_SHIPMENT)
  },
  setShipmentSchedule ({ commit, getters, rootGetters }, { shipmentID }) {
    commit(type.SET_SHIPMENT_SCHEDULE, { schedule: null })
    commit(type.SET_SHIPMENT_IS_FETCHING, { isFetching: true })
    commit(type.SET_SHIPMENT_FETCHING_ERROR, { error: null })
    // Add port to schedule
    let shipment = rootGetters['shipmentsContext/getSelectedShipment']
    if (shipment == null) {
      shipment = getters['getShipmentResourceDetails']
    }
    let quote = null
    if (shipment.type === 'ThreePL' && shipment.quotes != null) {
      const acceptedQuote = shipment.quotes.find(({ status }) => {
        return status === 'Accepted'
      })
      if (acceptedQuote != null) {
        quote = acceptedQuote
      }
    }
    shipmentService.getShipmentSchedule({ shipmentID, quote }).then((response) => {
      commit(type.SET_SHIPMENT_SCHEDULE, { schedule: response })
    }).catch((error) => {
      console.error(error)
      commit(type.SET_SHIPMENT_FETCHING_ERROR, { error })
    }).finally(() => {
      commit(type.SET_SHIPMENT_IS_FETCHING, { isFetching: false })
    })
  },
  setShipmentMap ({ commit }, { drops }) {
    shipmentHelper.createShipmentMapFromDrops({ drops }).then((response) => {
      commit(type.SET_SELECTED_SHIPMENT_SCHEDULE, { schedule: response })
    }).catch((error) => {
      console.error('error', error)
    })
  },
  setShipmentOverviewDrops ({ commit }, { shipmentID }) {
    commit(type.SET_SHIPMENT_IS_FETCHING, { isFetching: true })
    shipmentService.getShipmentWithDropsTransport({ shipmentID }).then((response) => {
      commit(type.SET_SELECTED_SHIPMENT, { shipment: response })
      commit('UPDATE_SELECTED_RESOURCE', { resource: { ...response } })
      commit(type.UPDATE_SELECTED_SHIPMENT_DROPS, { drops: response.drops })
    }).finally(() => {
      commit(type.SET_SHIPMENT_IS_FETCHING, { isFetching: false })
    })
  },
  setShipmentDetailDrops ({ commit }, { drops, existingDrops = [] }) {
    // commit(type.SET_SHIPMENT_IS_FETCHING, { isFetching: true })
    shipmentService.getBatchShipmentDrops({ dropIDs: drops }).then((response) => {
      const dropsResponse = [].concat(response, existingDrops)
      commit(type.SET_SELECTED_SHIPMENT_DETAIL_DROPS, { drops: dropsResponse })
    }).finally(() => {
      // commit(type.SET_SHIPMENT_IS_FETCHING, { isFetching: false })
    })
  },
  setShipmentLabels ({ commit }, { shipmentID, removed, added, newLabels }) {
    commit(type.SET_SELECTED_SHIPMENT_LABELS, { newLabels })
    shipmentService.updateShipmentLabels({ shipmentID, removed, added, labels: newLabels }).then(() => {
      commit('SHOW_SNACKBAR', { message: i18n.t('snackbars.shipment_labels_updated'), color: 'success' })
    }).catch((error) => {
      console.log(error)
      commit('SHOW_SNACKBAR', { message: i18n.t('snackbars.error'), color: 'error' })
    })
  },
  async fetchShipmentsByDates ({ commit }) {
    const shipmentsBydDates = await shipmentService.getShipmentsForNextDays(10)
    commit(type.SET_SHIPMENTS_BY_DATES, { data: shipmentsBydDates })
  },

  async fetchShipmentsForDay ({ commit }, day) {
    // console.log('day', day)
    const shipmentsInDay = await shipmentService.getShipmentsForDay(day)
    // console.log('shipmentsInDay', shipmentsInDay)
    commit(type.SET_SHIPMENTS_BY_DATES, { data: { [day]: shipmentsInDay } })
  },
  setHereMapObject ({ commit }, { hereMapObject }) {
    commit(type.SET_HERE_MAP_OBJECT, { hereMapObject })
  },
  removeHereMapObject ({ commit }) {
    commit(type.REMOVE_HERE_MAP_OBJECT)
  },
  setShipmentQuoteRequest ({ commit }, { shipmentID, comment, requests }) {
    quoteService.createRequests({ shipmentID, comment, requests }).then((response) => {
      commit('ADD_SECOND_RESOURCE_LIST_ITEM', { item: response })
    })
  },
  setIsShipmentDetails ({ commit }, { flag }) {
    commit(type.SET_IS_SHIPMENT_DETAILS, { flag })
  },
  setLocationPerScheduleStop ({ commit, getters }, { locationID }) {
    const locations = getters['getShipmentSchedule'].stops
    const index = locations.findIndex(({ location }) => {
      return location.id === locationID
    })
    commit(type.SET_LOCATION_PER_SCHEDULE_STOP, { location: locations[index].location })
    locationService.getLocation({ locationID }).then((response) => {
      commit(type.SET_LOCATION_PER_SCHEDULE_STOP, { location: response })
    })
  },
  setDropsPerScheduleStop ({ commit }, { shipmentID, locationID }) {
    shipmentService.getShipmentWithDropsUnitsCount({ shipmentID }).then((drops) => {
      commit(type.SET_DROP_PER_SCHEDULE_STOP, { locationID, drops })
    })
  },
  setShipmentAssignedDriverList ({ commit }, { organizationID }) {
    if (organizationID != null) {
      userService.listContacts({ organizationID }).then((response) => {
        const list = response.map((contact) => {
          return {
            ...contact,
            text: `${contact.name.given} ${contact.name.middle} ${contact.name.family} ${contact.position} ${contact.department}`
          }
        })
        commit(type.SET_ASSIGN_DRIVER_LIST, { list })
      })
    }
  },
  setShipmentAssignedVehicleList ({ commit }, { organizationID }) {
    if (organizationID != null) {
      vehicleService.listVehicles({ organizationID }).then((response) => {
        const list = response.map((vehicle) => {
          return {
            ...vehicle,
            text: `${vehicle.name} ${vehicle.plateNumber}`
          }
        })
        commit(type.SET_ASSIGN_VEHICLE_LIST, { list })
      })
    }
  },
  assignShipmentDriver ({ commit }, { shipment, driver }) {
    commit(type.SET_SELECTED_SHIPMENT, { shipment })
    commit('UPDATE_SELECTED_RESOURCE', { resource: { ...shipment } })
  },
  assignShipmentVehicle ({ commit }, { shipment, vehicle }) {
    commit(type.SET_SELECTED_SHIPMENT, { shipment })
    commit('UPDATE_SELECTED_RESOURCE', { resource: { ...shipment } })
  },
  handleSetGoodsValue ({commit}, {id, value}) {
    // console.log(id, value)
    commit(type.SET_GOODS_VALUE_FETCHING, { isFetching: true })
    shipmentService.setGoodsValue({ id, value }).then(() => {
      commit(type.GOODS_VALUE_UPDATED, {id, value})
      commit('SHOW_SNACKBAR', { message: i18n.t('snackbars.goods_value_updated'), color: 'success' })
    }).catch((error) => {
      console.log(error)
      // commit(type.QUOTE_LIST_ERROR, { errors: error })
      commit('SHOW_SNACKBAR', { message: i18n.t('snackbars.error'), color: 'error' })
    }).finally(() => {
      commit(type.SET_GOODS_VALUE_FETCHING, { isFetching: false })
    })
  },
  shipmentsSetShipmentSchedule({ commit }, { schedule }) {
    commit(type.SET_SHIPMENT_SCHEDULE, { schedule })
  },
  setShipmentsResetState({ commit }) {
    commit(type.SET_RESET_STATE)
  }
}

export default actions
